import { render, staticRenderFns } from "./SoDetail.vue?vue&type=template&id=bec0bfc0&scoped=true&"
import script from "./SoDetail.vue?vue&type=script&lang=js&"
export * from "./SoDetail.vue?vue&type=script&lang=js&"
import style0 from "./SoDetail.vue?vue&type=style&index=0&id=bec0bfc0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bec0bfc0",
  null
  
)

export default component.exports